import styled from 'styled-components';

type WrapperProps = {
  multiple?: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  max-width: 1280px;
  display: flex;
  align-items: stretch;
  gap: 8px;
  aspect-ratio: 16 / 9;

  justify-content: center;
  align-items: center;

  ${({ multiple }) => multiple && `
    & > div {
      flex: 0 0 calc(50% - 4px);
      max-width: calc(50% - 4px);
    }
  `}
`;

const VideoContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;

  .video-stage-placeholder {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: #fff;
    font-size: 14px;
  }

  .video-stage {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    overflow: hidden;
  }

  .live-video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .video-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 14px;
    gap: 8px;
    pointer-events: none;

    button {
      pointer-events: all;
    }
  }

  .video-overlay.buffering-overlay {
    background: rgba(0, 0, 0, 0.35);
  }

  .video-preview {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .stream-timer {
    position: absolute;
    bottom: 8px;
    left: 8px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 4px;
    padding: 4px 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    pointer-events: none;

    span {
      color: #fff;
      font-size: 12px;
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
    }
  }

  .quality-bar {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 10;

    select {
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.4);
      border-radius: 4px;
      padding: 2px 6px;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .video-stage-placeholder-actions {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  button {
    border: 1px solid white;
    border-radius: 6px;
    padding: 5px 15px;

    &:hover {
      border: 1px solid yellow;
    }

    &:disabled {
      border: 1px solid grey;
      background-color: grey;
      cursor: default;
    }
  }
`;

const ModalStyle = styled.div`
  .select-stream-duration{
    display: flex;
    min-width: 250px;
    float: right;
    p {
      font-size: 13px;
      margin: auto;
    }
    div {}
  }

  .tab-content {
    margin: 8px 0 0 0;
  }
`;

export default { Wrapper, ModalStyle, VideoContainer };
